export default __webpack_public_path__ + "static/char-35-57b7cbdcbd1d824b0a70f5279e02da7f.gif";